<template>
    <modal class="modal" printButton downloadButton :close="closeModal" :title="title" :printStyle="printStyle">
        <h3 class="modal__header" slot="modalHeader"><i class="uk-icon-hand-o-up"></i> Исполнительные производства {{companyName}}</h3>
        <div class="modal__content" slot="modalBody">
            <template v-if="!isLoading && list && list.length">
                <h4 class="cases-title">{{execTitle}} <i class="uk-icon-rub"></i></h4>
                <ul>
                    <executory-item v-for="(c, i) in list" :key="i" :exec="c" />
                </ul>
            </template>
            <loading v-if="isLoading" />
        </div>
        <div class="modal__footer" slot="modalFooter">
            <old-pagination 
                v-if="paginationObj && paginationObj.rows_count > 100" 
                :paginationObj="paginationObj" 
                :getNewContent="nextPage" 
            />
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import loading from '@/components/ui/loading/loading.vue'
import executoryItem from '@/components/card/executory/executoryItem.vue'
import oldPagination from '@/components/ui/oldPagination/oldPagination.vue'

export default {
    components: {
        modal,
        loading,
        executoryItem,
        oldPagination
    },
    props: {
        companyName: String,
        title: String,
        stat: Object
    },
    data: () => ({
        printStyle: `
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
                }
            ul { padding: 0; }
            .modal__content { font-family: Helvetica, Arial, Tahoma, sans-serif; color: #000; }
            .cases-title { font-family: inherit; }
            .cases-title { font-size: 20px; font-weight: bold; }
            .item {
                margin-top: 30px; 
                border-bottom: 1px solid #ddddde;
                display: flex;
                flex-direction: column;
                gap: 6px;
                padding-bottom: 6px; 
            }
            .item__title { font-size: 20px; }
            .item__title .number { color: #3498db; }
            .item__title .status {font-size: 14px; font-weight: bold; margin-left: 20px;}
            .uk-icon-rub::before { content: '₽' !important; font-style: normal; font-weight: 700; }
        `
    }),
    computed: {
        list() { return this.$store.state.card?.executory?.infoList || [] },
        isLoading() { return this.$store.state.card?.executory?.isLoading },
        currentExec() { return this.$store.state.card?.executory?.currentExec },
        paginationObj() { return this.$store.state.card?.executory?.paginationObj },
        currentTotalCount() {
            if(this.currentExec?.status !== 'all') {
                return this.$props.stat?.[this.currentExec.year]?.[this.currentExec.status]?.count_total
            } else {
                return this.$props.stat?.[this.currentExec.year].opened.count_total + this.$props.stat?.[this.currentExec.year].closed.count_total
            }
        }, 
        currentTotalSum() {
             if(this.currentExec?.status !== 'all') {
                return this.moneyFormat(this.$props.stat?.[this.currentExec.year]?.[this.currentExec.status]?.sum_total, 2)
            } else {
                return this.moneyFormat(this.$props.stat?.[this.currentExec.year].opened.sum_total + this.$props.stat?.[this.currentExec.year].closed.sum_total, 2)
            }
        },
        execTitle() {
            if(this.currentExec?.status === 'opened') {
                return `Выступает в ${this.currentExec?.year} году в качестве должника в ${this.currentTotalCount} открытых исполнительных производствах на общую сумму: ${this.currentTotalSum}`
            } else if(this.currentExec?.status === 'closed') {
                return `Выступал в ${this.currentExec?.year} году в качестве должника в ${this.currentTotalCount} исполнительных производствах на общую сумму: ${this.currentTotalSum}`
            } else if(this.currentExec?.status === 'all') {
                return `Выступает в ${this.currentExec?.year} году в качестве должника в ${this.currentTotalCount} исполнительных производствах на общую сумму: ${this.currentTotalSum}`
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.dispatch('card/executory/closeModal')
        },
        nextPage(limit = 100, offset = 0) {
            this.$store.dispatch('card/executory/getInfo', {
                year: this.currentExec.year,
                status: this.currentExec.status,
                limit,
                offset
            })
        }
    }
}
</script>

<style lang="sass" scoped>
.modal
    &__content
        padding: 20px 20px 20px 50px
        .cases-title
            font-size: 22px
        ul
            padding: 0
    &__header
        font-family: Arial,Tahoma,sans-serif
        font-weight: 100
        font-size: 24px
        line-height: 24px
    &__footer
        width: 30%
        float: left
        display: flex
        justify-content: flex-start
</style>